export const addSearch = <T>(data: T[] = [], props: string[]): T[] => {
    return data.map((resData) => ({
        ...resData,
        $search: props
            .map((prop) => resData[prop])
            .join(" ")
            .toLowerCase(),
    }));
};
